import {Badge} from '@cohort/merchants/components/Badge';

type DigitalAssetReferenceComponentProps = {
  internalName: string;
  tokenId?: number;
};

const DigitalAssetReferenceComponent: React.FC<DigitalAssetReferenceComponentProps> = ({
  internalName,
  tokenId,
}) => (
  <div className="flex w-full flex-row items-center space-x-2">
    <p className="line-clamp-2 font-normal">{internalName}</p>
    {tokenId !== undefined && (
      <Badge
        text={`#${tokenId}`}
        textColor="text-slate-500"
        backgroundColor="bg-slate-100"
        size="large"
      />
    )}
  </div>
);

export default DigitalAssetReferenceComponent;
